import type { Event } from '@patsnap/tahiti-core';
import type { GetClaimCompareTranslationParams, FeatureDismantlingState, ClaimFeatureItem } from '../types';

export const FeatureDismantlingService = Symbol.for('FeatureDismantlingService');

export interface FeatureDismantlingService {
    readonly onStatesChange: Event<FeatureDismantlingState>;
    getModelData(): FeatureDismantlingState;
    updateModelData(data: Partial<FeatureDismantlingState>): void;

    getClaimFeatureData(patentId: string): Promise<void>; // 获取权力要求特征数据
    mergeClaimFeature(name: string, source: number, target: number): void; // 合并权力要求特征
    deleteClaimFeature(name: string, target: number): void; // 删除权力要求特征

    getFeatureTranslation(params: GetClaimCompareTranslationParams): Promise<void>; // 获取翻译数据
    saveClaimFeatureData(data: ClaimFeatureItem[]): Promise<void>; // 本地存储数据

    exportExcel(data: ClaimFeatureItem[]): Promise<void>; // 导出
    reset(): void; // 重置
}